/** `550e8400-e29b-41d4-a716-446655440000` */
const UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/** `123` */
const NUMERIC_SEGMENT = /^\d+$/;
/** `2026-09-10` — 식별자는 아니지만 그대로 두면 날마다 새 패턴이 생긴다. */
const DATE_SEGMENT = /^\d{4}-\d{2}-\d{2}$/;
/** Django i18n URL prefix. `apiClient` 의 baseURL 에 이미 들어 있다. */
const LOCALE_PREFIX = /^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i;

/**
 * 요청 URL 을 집계 가능한 엔드포인트 패턴으로 바꾼다.
 *
 * URL 을 그대로 이벤트 프로퍼티로 보내면 프로젝트·로그 id 마다 항목이 갈라져
 * "어떤 API 가 얼마나 실패하는가"를 셀 수 없다(카디널리티 폭발). 식별자로 보이는
 * 경로 세그먼트를 자리표시자로 치환해 화면이 아니라 **엔드포인트** 단위로 묶는다.
 *
 * 쿼리스트링은 통째로 버린다 — 값이 그대로 남으면 정규화의 의미가 없고,
 * 검색어 같은 사용자 입력이 분석 도구로 새어 나갈 수 있다.
 *
 * @example
 * toEndpointPattern("/api/projects/123/daily-logs/456") // "/api/projects/:id/daily-logs/:id"
 */
export function toEndpointPattern(rawUrl: string | undefined): string {
  if (!rawUrl) return "(unknown)";

  // 절대 URL 이면 origin 을, 상대 경로면 쿼리·해시를 떼어낸다.
  const path = rawUrl.includes("://")
    ? safePathname(rawUrl)
    : `/${(rawUrl.split(/[?#]/)[0] ?? "").replace(/^\/+/, "")}`;

  return path.replace(LOCALE_PREFIX, "").split("/").map(normalizeSegment).join("/");
}

function safePathname(rawUrl: string): string {
  try {
    return new URL(rawUrl).pathname;
  } catch {
    return rawUrl;
  }
}

function normalizeSegment(segment: string): string {
  if (NUMERIC_SEGMENT.test(segment)) return ":id";
  if (UUID_SEGMENT.test(segment)) return ":uuid";
  if (DATE_SEGMENT.test(segment)) return ":date";
  return segment;
}
